import React from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { HANDLE_REGEX, WizardFormData } from "./types";

const StepClaimHandle: React.FC<{
  formData: WizardFormData;
  onChange: (updates: Partial<WizardFormData>) => void;
  onBack: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}> = ({ formData, onChange, onBack, onSubmit, isSubmitting }) => {
  const handleValue = formData.handle.trim().toLowerCase();
  const isValid = handleValue.length > 0 && HANDLE_REGEX.test(handleValue);

  return (
    <div className="wizard-card">
      <div className="wizard-header">Claim Your Handle</div>
      <div className="wizard-description">
        Choose a unique handle for your public listing URL.
      </div>

      <Form.Group className="mb-3">
        <Form.Label htmlFor="wizard-handle">Handle</Form.Label>
        <InputGroup>
          <InputGroup.Text className="handle-prefix">
            vcdb.app/company/
          </InputGroup.Text>
          <Form.Control
            id="wizard-handle"
            name="handle"
            type="text"
            placeholder="your-company"
            value={formData.handle}
            onChange={(e) =>
              onChange({ handle: e.target.value.toLowerCase().trim() })
            }
          />
        </InputGroup>
        <Form.Text className="text-muted">
          Lowercase letters, numbers, and hyphens only.
        </Form.Text>
      </Form.Group>

      <div className="wizard-nav">
        <Button variant="outline-secondary" onClick={onBack}>
          Back
        </Button>
        <Button
          variant="primary"
          onClick={onSubmit}
          disabled={!isValid || isSubmitting}
        >
          {isSubmitting ? "Creating..." : "Create Listing"}
        </Button>
      </div>
    </div>
  );
};

export default StepClaimHandle;
